// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */

import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import type {ProfileProviderDispatchProps, ProfileProviderStateProps} from "../../components/profile/ProfileProvider";
import ProfileProvider from "../../components/profile/ProfileProvider";

const mapStateToProps = (state: StoreState): ProfileProviderStateProps => {

    return {
        profile: state.profile
    };
};

const mapDispatchToProps = (dispatch): ProfileProviderDispatchProps => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileProvider);



// WEBPACK FOOTER //
// ./src/containers/profile/ProfileProvider.js